import React, { useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import { useParams, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import {
  goodsItemsGetAction,
  purchaseItemsGetAction,
  purchaseReturnViewAction,
} from "../../../redux/actions/purchase-action";
import CreateEditViewPurReturn from "../../../components/purchase-section/purchase-return/create-edit-view-pur-return";

const AddPurchaseReturn = () => {
  const { itemId, type } = useParams();
  const itemIdArray = JSON.parse(decodeURIComponent(itemId));

  const [searchParams] = useSearchParams();

  //

  const cloneID = searchParams.get("cloneID");
  const isClone = cloneID ? true : false;
  //

  const allitems = itemIdArray.map((item) => {
    const { cmr_id, ...rest } = item;
    return rest;
  });
  const [orderDetail, setOrderDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {}, []);

  useEffect(() => {
    if (isClone) {
      setLoading(true);

      dispatch(purchaseReturnViewAction(cloneID, onCloneSuccPur, onErrPur));
    } else if (type === "purchase") {
      setLoading(true);
      dispatch(purchaseItemsGetAction(allitems, onSuccPur, onErrPur));
    } else if (type === "goods") {
      setLoading(true);
      dispatch(goodsItemsGetAction(allitems, onSuccPur, onErrPur));
    }
  }, []);

  const onCloneSuccPur = (data) => {
    setOrderDetail(data?.data?.[0]);
    setLoading(false);
  };
  const onSuccPur = (data) => {
    setOrderDetail(data?.data);
    setLoading(false);
  };

  const onErrPur = (data) => {
    setLoading(false);
  };
  const orderData = orderDetail?.orderData || {};
  const vendorDetails = orderDetail?.vendorDetails?.[0] || {};
  const prefix = searchParams.get("type") || "gort";
  const isNew = searchParams.has("new");

  return (
    <InnerLayout
      backBtn={true}
      title={`${isClone ? "Clone" : "Add"} Purchase Return`}
    >
      {loading ? (
        <LoadingSpinner />
      ) : (
        <CreateEditViewPurReturn
          isClone={isClone}
          clickedplus={isNew}
          payto={
            isClone
              ? orderDetail?.orderData?.prt_pay_to_address
              : vendorDetails?.[`${prefix}_pay_to_address`]
          }
          shipto={
            isClone
              ? orderDetail?.orderData?.prt_ship_to_address
              : vendorDetails?.[`${prefix}_ship_to_address`]
          }
          page="add"
          pageType="purchase return"
          type={type}
          orderDetail={orderDetail?.itemData}
          vendorDetails={
            isClone
              ? [orderDetail?.orderData]
              : [
                  {
                    ...vendorDetails,
                    prt_sub_total: orderData?.sub_total,
                    prt_total_gst: orderData?.total_tax,
                    prt_total_discount: orderData?.total_discount,
                    prt_total_amount: orderData?.total_amount,
                    prt_round_off_value: orderData?.round_off_value,
                    prt_tcs_or_tds_amount: orderData?.tcs_or_tds_amount,
                    prt_tcs_or_tds_percentage_id:
                      orderData?.tcs_or_tds_percentage_id,
                    prt_tcs_or_tds_percentage: orderData?.tcs_or_tds_percentage,
                    prt_tds_tcs_type: orderData?.tcs_or_tds_type,
                    prt_is_invoice_dis_percentage:
                      orderData?.is_invoice_dis_percentage ?? true,
                    prt_invoice_discount: orderData?.invoice_discount ?? 0,
                    prt_invoice_discount_percentage:
                      orderData?.invoice_discount_percentage ?? 0,
                  },
                ]
          }
        />
      )}
    </InnerLayout>
  );
};

export default AddPurchaseReturn;
